<template>
    <div :class="{goodsFilter:!isMobile,
    goodsFilterThis:!isMobile,
    mgoodsFilter:isMobile,
    mgoodsFilterThis:isMobile,
    mobileCommon:isMobile,
    }">
        <div class="filName">{{ langPage['v4-commandes']['TXT_filters'] }}</div>
        <el-collapse accordion>
            <el-collapse-item name="vendeurType">
                <template slot="title">
                    <i class="el-icon-arrow-down filArraw"></i>{{ 'FAVORIS' }}
                </template>
                <div class="kidList">
                    <el-radio-group v-model="filterList['vendeurType']" @change="check()">
                        <el-radio v-for="(vendeurType,typeIndex) of vendeurTypes"
                                  class="filterKid"
                                  :key="typeIndex"
                                  :label="vendeurType.value">{{ vendeurType.lable + `(${vendeurType.value == 'all' ? totalCount : totalCollectCount})` }}
                        </el-radio>
                    </el-radio-group>
                </div>
            </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
            <el-collapse-item name="remiseType">
                <template slot="title">
                    <i class="el-icon-arrow-down filArraw"></i>{{ 'TYPE DE REMISE' }}
                    <div class="clearBtn" @click.stop="effacer('remiseType')">{{ langPage['grossistes-liste']['TXT_effacer'] }}</div>
                </template>
                <div class="kidList">
                    <el-radio-group v-model="filterList['remiseType']" @change="check()">
                        <el-radio v-for="(remiseType,typeIndex) of remiseTypes"
                                  class="filterKid"
                                  :key="typeIndex"
                                  :label="remiseType">{{ remiseType }}
                        </el-radio>
                    </el-radio-group>
                </div>
            </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
            <el-collapse-item name="vendeurs">
                <template slot="title">
                    <i class="el-icon-arrow-down filArraw"></i>{{ langPage['catalogue-promotions']['TXT_promotions'].toUpperCase() }}
                    <div class="clearBtn" @click.stop="effacer('promot')">{{ langPage['grossistes-liste']['TXT_effacer'] }}</div>
                </template>
                <div class="kidList">
                    <el-input
                        :placeholder="'searchVendeur'"
                        v-model="searchVendeurName"
                        class="searchInput"
                        v-on:keyup.native.enter="searchVendeurByName">
                        <i
                            class="el-input__icon el-icon-search"
                            slot="suffix"
                            @click="searchVendeurByName"
                        ></i>

                    </el-input>
                    <el-checkbox-group v-model="choosedVendeurs">
                        <el-checkbox @change="emitChooseVendeur(choosedVendeurs)" :checked="checked" class="filterKid"
                                     v-for="(vendeurRemise,promotIndex) in searchedVendeurs" :key="promotIndex"
                                     :label="vendeurRemise">{{ vendeurRemise.vendeur.nomBoutique }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import filterList from "./filterList";

export default {
    name: "promotionsFilter",
    props: {
        filterList: Object,
        dataList: Array,
        totalCount: Number,
        totalCollectCount: Number,
    },
    components: {
        filterList
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    watch: {
        filterList(val) {
            this.$forceUpdate();
        },
        'dataList': {
            immediate: true,
            handler(val) {
                this.getAllVendeurData();
                this.$forceUpdate();
            }
        },
        totalCount(val) {
            this.$forceUpdate();
        },
        totalCollectCount(val) {
            this.$forceUpdate();
        },
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            checked: false,
            vendeurTypes: [
                {
                    lable: this.$store.state.langPage['codepromo']['TXT_touslesvendeurs'],
                    value: 'all'
                },
                {
                    lable: this.$store.state.langPage['codepromo']['TXT_mesgrossistes'],
                    value: 'collect'
                },
            ],
            remiseTypes: [
                'reduction', 'pourcentage'
            ],
            promotonsData: {},
            searchVendeurName: '',
            choosedVendeurs: [],
            searchedVendeurs: [], //搜索显示的商家数据
            allVendeurs: [], // 所有的商家数据
        }
    },
    mounted() {
    },
    methods: {
        effacer(data) {
            switch (data) {
                case 'vendeurType':
                    this.filterList.vendeurType = null;
                    this.check()
                    break;
                case 'remiseType':
                    this.filterList.remiseType = null;
                    this.check()
                    break;
            }
        },
        check() {
            this.$common.EventBus.$emit('loadmore')
        },
        // 获取所有商家的数据
        getAllVendeurData() {
            for (let promotion of this.dataList) {
                if (!this.allVendeurs.includes(promotion)) this.allVendeurs.push(promotion);
            }
            this.searchVendeurByName();
        },
        searchVendeurByName() {
            this.searchedVendeurs = [];
            for (let promotion of this.allVendeurs) {
                let vendeurName = promotion.vendeur.nomBoutique;
                if (vendeurName.toLowerCase().includes(this.searchVendeurName.toLowerCase())) {
                    this.searchedVendeurs.push(promotion);
                }
            }
        },
        emitChooseVendeur(data) {
            let vendeurs = [];
            this.$emit('chooseVendeur', data)
        },
    },
}
</script>
<style>
/*.el-checkbox__label{*/
/*    display: inline;*/
/*}*/
/*!*可以浪el-checkbox的内容进行换行，不过不会填满整行*!*/
/*.el-checkbox, .el-checkbox__input{*/
/*    white-space: normal;*/
/*    word-break: break-all;*/
/*}*/
.goodsFilterSecondFilterList {
    margin-left: 1.5vw;
}
</style>
<style scoped lang="less">
.goodsFilterThis {
    width: 244px;

    .filName {
        font-size: 20px;
        line-height: 30px;
        font-family: Ogg-Roman;
    }

    .filArraw {
        white-space: nowrap;
    }

    .kidListCategory {
    }

    .kidList {
        padding-left: 15px;
        // max-height: 3rem;
        .btn {
            display: inline-block;
            height: .38rem;
            width: 20%;
            font-size: .14rem;
            color: #FFFFFF;
            background-color: #000;
            line-height: .38rem;
            text-align: center;
            cursor: pointer;
        }

        .filterKid {
            font-size: 14px;
            font-family: MaisonNeue-Medium;
            display: block;
        }

        .el-checkbox {
            display: block;
        }

        .searchInput {
            width: 100%;
        }
    }

    .colorBox {
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;

        .colorCol {
            flex: 0 0 20%;
            height: 30px;

            .colorBorder {
                width: 25px;
                height: 25px;
                border-radius: .125rem;
                box-sizing: border-box;

                &.act {
                    border: 1px solid #000000;
                }
            }

            .colorBtn {
                width: 20px;
                height: 20px;
                border-radius: 10px;
                overflow: hidden;
                box-sizing: border-box;
                margin-top: .017rem;
                margin-left: .017rem;

                &.act {
                    border: 1px solid #000000;
                }

                &.double {
                    transform: rotate(25deg);

                    .color {
                        width: 10px;
                        display: inline-block;
                    }
                }

                .color, .grain {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }


}

.mgoodsFilterThis {
    width: 80vw;
    height: 100vh;

    .filName {
        font-size: 14pt;
        line-height: 3vw;
        font-family: Ogg-Roman;
    }

    .kidListCategory {
    }

    .kidList {
        padding-left: 5vw;
        // max-height: 3rem;
        .btn {
            display: inline-block;
            font-size: 12pt;
            color: #FFFFFF;
            background-color: #000;
            text-align: center;
            cursor: pointer;
        }

        .filterKid {
            font-size: 10pt;
            font-family: MaisonNeue-Medium;
            display: block;
        }

        .el-checkbox {
            display: block;
        }

        .searchInput {
            width: 100%;
        }
    }

    .colorBox {
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;

        .colorCol {
            .colorBorder {
                border-radius: 100vw;
                box-sizing: border-box;
                margin-right: 1vw;

                &.act {
                    border: 1px solid #000000;
                }
            }

            .colorBtn {
                width: 5vw;
                height: 5vw;
                border-radius: 100vw;
                overflow: hidden;
                box-sizing: border-box;
                margin: 2vw;

                &.act {
                    border: 1px solid #000000;
                }

                &.double {
                    transform: rotate(25deg);

                    .color {
                        width: 2vw;
                        display: inline-block;
                    }
                }

                .color, .grain {
                    width: 8vw;
                    height: 8vw;
                }
            }
        }
    }


}

/deep/ .el-collapse-item__header {
    font-family: MaisonNeue-Medium;
    font-weight: 500;
}

/deep/ .el-icon-arrow-down:before {
    margin-right: 0.069rem;
}

/deep/ .el-icon-arrow-down:before {
    margin-left: 0.069rem;
}

/deep/ .el-checkbox__inner::after {
    left: 0;
    width: 0.04rem;
    height: 10px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}

/deep/ .el-input__inner {
    padding-left: 0;
    padding-right: 0;
    padding: 0 0.03rem;
    box-sizing: border-box;
}
</style>
